module.exports = __webpack_public_path__ + "static/savras-symbol-DND3_FnP-f11a5e167079140e84f8d4aaf5dd688b.jpg";